import styled from "styled-components";
import { colors } from "../../../common/ui/globalColors";

export const StyledPayments = styled.div`
    .payments-wrapper {
        border: 1px solid ${colors.semiTransparentColors.blue};
        border-radius: 28px;
        margin-top: 25px;
        padding: 33px 24px;

        .payments {
            display: flex;
            flex-direction: column;
            gap: 14px;

            .titles {
                display: grid;
                grid-template-columns: repeat(9, 1fr);
                font-weight: 700;
                font-size: 12px;
                line-height: 14px;
                color: ${colors.semiTransparentColors.grayBlue};
                margin-left: 50px;
                padding: 0 18px;
                text-align: center;
                gap: 5px;
                direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
            }
        }
    }
`
